export default {"src":"/_next/static/media/back-arr.37686df5.svg","height":23,"width":55,"blurWidth":0,"blurHeight":0};